"use strict";
exports.__esModule = true;
exports.ServiceType = void 0;
var ServiceType;
(function (ServiceType) {
    ServiceType["category"] = "category";
    ServiceType["categoryItem"] = "categoryItem";
    ServiceType["categoryLevel"] = "categoryLevel";
    ServiceType["chain"] = "chain";
    ServiceType["chainNodeDef"] = "chainNodeDef";
    ServiceType["node"] = "node";
    ServiceType["nodeDef"] = "nodeDef";
    ServiceType["record"] = "record";
    ServiceType["survey"] = "survey";
    ServiceType["taxon"] = "taxon";
    ServiceType["taxonomy"] = "taxonomy";
    ServiceType["user"] = "user";
})(ServiceType = exports.ServiceType || (exports.ServiceType = {}));
//# sourceMappingURL=serviceType.js.map